<p-button icon="pi pi-sliders-h" [rounded]="true" severity="secondary" text="true" [outlined]="true"
    (click)="prefs.toggle($event)"
    pTooltip="Preferences" tooltipPosition="left"/>
<p-popover #prefs [style]="{marginLeft:'1.375rem'}" styleClass="header-popover flex flex-col">
    <app-theme-picker (changed)="hide()"></app-theme-picker>
    <app-font-size-select (changed)="hide()"></app-font-size-select>
</p-popover>
